import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-published',
  templateUrl: './video-published.component.html',
  styleUrls: ['./video-published.component.scss']
})
export class VideoPublishedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }
  @Input() public bought;
  @Input() public message;
  @Input() public title;
  
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
